// -----------------------------------------------------------------------------
//
// This file defines Amplitude feature flags used in the application.
//
// Amplitude Feature Flags:
// https://app.amplitude.com/experiment/warnermusicgroup/flags
//
// -----------------------------------------------------------------------------
export const FEATURE_FLAGS = {
  ContainerSettingsSublabelRequest:
    'container_settings_sublabel_request_enabled',
  ContainerProfile: 'container_profile_enabled',
  ContainerDdexConsole: 'container_ddex_console_enabled',
  SettingsInternalUserUpdates: 'settings_internal_user_updates',
  ContainerSettingsLabelAdminUserCreation:
    'container_settings_label_admin_user_creation_enabled',
  WmgAssetPerformance: 'wmg_asset_performance_enabled',
  WmgTrackDetails: 'wmg_track_details_enabled',
  WmgTrackPreReleases: 'wmg_track_pre_releases_enabled',
  WmgTrackSetBenchmarks: 'wmg_track_set_benchmarks_enabled',
  WmgTrackCompareBenchmark: 'wmg_track_compare_benchmark_enabled',
  WmgArtistContacts: 'wmg_artist_contacts_enabled',
  WmgArtistCollaboratorTracks: 'wmg_artist_collaborator_tracks_enabled',
  WmgCampaignBenchmarks: 'wmg_frontend_campaign_benchmarks',
  WmgMediaPlanCampaigns: 'wmg_frontend_media_plan_campaigns',
  WmgMarketingDigitalCampaignPerformanceDashboard:
    'wmg_marketing_digital_campaign_performance_dashboard',
  WmgMarketingAnomalyDashboardEnabled:
    'wmg_marketing_anomaly_dashboard_enabled',
  WmgMarketingAutomatedCampaignsEnabled:
    'wmg_marketing_automated_campaigns_enabled',
  WmgHomepageUsesEmbeddedContent: 'wmg_homepage_uses_embedded_content',
  WmgUserManagement: 'wmg_user_management',
  WmgDigitalCampaignsMediaPlanningEnabled:
    'wmg_digital_campaigns_media_planning_enabled',
  WmgLabelPerfMaintenanceEnabled: 'wmg_label_perf_maintenance_enabled',
  WmgReleaseManagement: 'wmg_release_management',
  WmgDataMusicIqChatbotEnabled: 'wmg_data_music_iq_chatbot_enabled',
  WmgDigitalCampaignsEmbedDashboardEnabled:
    'wmg_digital_campaigns_embed_dashboard_enabled',
  WmgAutomatedCreatorCampaignsEnabled:
    'wmg_automated_creator_campaigns_enabled',
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
